import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from '../footer';
import Header from '../header';
import '../../sass/_layout.scss';
import cookie from 'next-cookies';
import HeaderTag from '../header-tag';
const Layout = (props) => {
    // /static/images/test-main-img.png
    let image_path = 'https://api.gadgetzippy.com/brandImages/test-main-img.png'
    image_path = `https://api.gadgetzippy.com/brandImages/${cookie({ "ctx": '' }).brand_image ? cookie({ "ctx": '' }).brand_image : 'test-main-img.png'}`;
    let mobile_image_path = 'https://api.gadgetzippy.com/brandImages/phone-Bg.png';
    mobile_image_path = `https://api.gadgetzippy.com/brandImages/${cookie({ "ctx": '' }).mobile_brand_image ? cookie({ "ctx": '' }).mobile_brand_image : 'phone-Bg.png'}`;
    return (
        <div className={props.route == undefined ? '' : (props.route ? props.asRoute == true ? "" : "layout-bg" : "layout-bg")}>
            <div className="desktop"><HeaderTag isChecked={props.isChecked} /></div>
            <Header checkedBox={props.checkedBox} route={props.route} location={props.location} isHome={props.isHome} handleOpen={props.handleOpen} myroute={props.myroute} offers={props.offers} />
            <section>
                {props.children}
            </section>
            {props.route == undefined ? <div></div> : (props.route == true ? (props.asRoute == true || props.asContact == true) ? <div className=""><Footer isHome={props.isHome} onLoad={props.onLoad} /></div> : <div className="desktop"><Footer isHome={props.isHome} onLoad={props.onLoad} /></div> : <Footer isHome={props.isHome} onLoad={props.onLoad} />)}
            <style jsx global>
                {`
                .layout-bg{
                    background-image: url('${image_path}');
                    background-position: left top;
                    background-repeat: no-repeat;
                    background-size: auto;
                }
                @media only screen and (max-width: 1080px){ 
                    background-size: 55% !important; 
                }
                @media only screen and (max-width: 768px){
                    .layout-bg{
                        background-image: url('${mobile_image_path}');
                        background-position: left top;
                        background-repeat: no-repeat;
                        background-size: 60% !important; 
                    }                
                }
                @media only screen and (max-width: 765px){
                    .layout-bg{
                        background-image: url('${mobile_image_path}');
                        background-position: right top;
                        background-repeat: no-repeat;
                        background-size: 100% !important; 
                    }                
                }
                `}
            </style>
        </div>
    )
}
export default Layout;
